import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { okResponse } from '../../../routes/defaultResponses';
import { makeNullable } from '../../../utils/typeboxHelpers';
import { surveyTaskTableSchema } from './surveyTaskTableSchema';

export const surveyTaskPaths = {
    '/api/surveys/{surveyId}/tasks': {
        get: {
            operationId: 'surveyTaskControllers.getAll',
            parameters: [{ name: 'surveyStatus', in: 'query', schema: Type.String() }, createPathGuidParameter('surveyId')],
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(
                                    Type.Intersect([
                                        Type.Pick(surveyTaskTableSchema, [
                                            'id',
                                            'name',
                                            'order',
                                            'surveyStatus',
                                            'progressStatus',
                                            'updatedOn',
                                            'remark',
                                        ]),
                                        Type.Object({
                                            updatedByUser: Type.Object({
                                                id: makeNullable(Type.String()),
                                                firstName: makeNullable(Type.String()),
                                                lastName: makeNullable(Type.String()),
                                            }),
                                        }),
                                    ]),
                                ),
                            }),
                        },
                    },
                },
            },
        },
        put: {
            operationId: 'surveyTaskControllers.updateMany',
            parameters: [createPathGuidParameter('surveyId')],
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            items: Type.Array(Type.Pick(surveyTaskTableSchema, ['id', 'remark', 'progressStatus'])),
                        }),
                    },
                },
            },
            responses: {
                ...okResponse,
            },
        },
    },
} as const;
